import { render, staticRenderFns } from "./OptionMenu.vue?vue&type=template&id=31bf1d82"
import script from "./OptionMenu.vue?vue&type=script&lang=js"
export * from "./OptionMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports